export enum CountryOfRegistrationEnum {
    EnglandAndWales = "England and Wales",
    NorthernIreland = "Northern Ireland",
    Scotland = "Scotland"
}
